import React from 'react';
import { Box } from '@mui/material';
// import AspectRatio from '@mui/joy/AspectRatio';

interface Props {
  gridArea: string;
}
export const ITSImage = (props: Props) => {
  const { gridArea } = props;
  return (
    <Box
      sx={{
        gridArea: { gridArea },
        height: '100%',
        width: '100%',
        objectFit: 'contain',
      }}
      component={'img'}
      src='./img/cit-logo.png'
    />
  );
};
